exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text--theme--primary {\n  color: #1B5E73 !important;\n}\n.text--theme--accent {\n  color: #FFD93D !important;\n}\n.text--theme--secondary {\n  color: #757575 !important;\n}\n.text--theme--error {\n  color: #b71c1c !important;\n}\n.text--theme--warning {\n  color: #F4511E !important;\n}", ""]);

// exports
